import { Theme } from '@mui/material/styles'
import * as system from '@mui/system'

/** This type allows to specify the value or the value by the breakpoints */
export type AdaptiveValue<T> = T | { [K in system.Breakpoint]?: T }

export const direction = system.style({
	prop: 'direction',
	cssProperty: 'flexDirection',
})

export const gap = system.style({
	prop: 'gap',
	cssProperty: 'gap',
	themeKey: 'spacing',
})

export type GapProps = { gap?: AdaptiveValue<NonNullable<React.CSSProperties['gap']>> }

/** Spacing is the same as gap, but MUIv5 uses the `spacing` prop instead of `gap` */
export const spacing = system.style({
	prop: 'spacing',
	cssProperty: 'gap',
	themeKey: 'spacing',
})

export const full = system.compose(
	system.borders,
	system.display,
	system.flexbox,
	gap,
	system.positions,
	system.palette,
	system.shadows,
	system.sizing,
	system.spacing,
	system.typography,
)

export type FullProps = system.BordersProps &
	system.DisplayProps &
	system.FlexboxProps &
	GapProps &
	system.PositionsProps &
	system.PaletteProps &
	system.Shadows &
	system.SizingProps &
	system.SpacingProps &
	system.TypographyProps

/** Unfortunately `styleFunctionSx()` has bugs in this old MUI version. Remove after upgrade to MUIv5 */
export const sx: system.StyleFunction<{ sx?: FullProps; theme?: Theme }> = (p) =>
	p.sx ? full({ theme: p.theme, ...p.sx }) : undefined

/** @deprecated Use MUI */
export type SxProps = { sx?: FullProps }
